import { Component, Input, OnInit } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ChatHttpService } from '../../../../services/chat-http.service';
import { ChatService } from '../../../../services/chat.service';

@Component({
  selector: 'nz-modal-delete-chat',
  templateUrl: './delete-chat.component.html',
  styleUrls: ['./delete-chat.component.scss']
})
export class NzModalDeleteChatComponent implements OnInit {
  @Input() cancelTextBtn: string = 'Отменить';
  @Input() confirmTextBtn: string = 'Отправить';
  @Input() user: string;
  @Input() chatID: number;


  serverError: any;
  unsubscribe$ = new Subject();
  ids = [1, 2, 3, 4, 5, 6];
  isSuccess = false;

  constructor(private modal: NzModalRef,
              private chatHttp: ChatHttpService,
              private chatService: ChatService) { }

  ngOnInit(): void {
  }
  destroyModal(): void {
    this.unsubscribe();
    this.modal.destroy();
  }

  confirmModal() {
    this.unsubscribe();
    this.modal.destroy({ data: true });
  }

  unsubscribe() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  submit() {
    this.chatHttp.chatDelete({ChatID: this.chatID}).subscribe(x => {
      this.isSuccess = true;
      this.chatService.chatUpdate();
    }, error => {
      this.serverError = error.error.detail;
    })
  }
}
